import { CartPricing, PositionDiscountPreview } from '../types';
import { getFiGrowthBook } from './growthbook';

const POSITION_DISCOUNT_FEATURE_FLAG = 'multipet-position-discount';

/**
 * Calculates the discounted price for a subscription based on position discount.
 */
export function calculatePositionDiscountedPrice(basePriceInCents: number, discountPercent: number): number {
  return Math.round(basePriceInCents * (1 - discountPercent / 100));
}

/**
 * Calculates the savings amount for a subscription based on position discount.
 */
export function calculatePositionSavings(basePriceInCents: number, discountPercent: number): number {
  return Math.round(basePriceInCents * (discountPercent / 100));
}

/**
 * Gets the position discount for a specific cart item, if enrolled in the experiment.
 */
export function getPositionDiscountForCartItem(
  cartPricing: CartPricing,
  cartItemId: string,
): PositionDiscountPreview | null {
  const discount = cartPricing.positionDiscounts?.[cartItemId];
  if (!discount || !discount.isEnrolled || discount.discountPercent === 0) {
    return null;
  }
  return discount;
}

/**
 * Checks if user is enrolled in position discount experiment.
 * Prefers backend response (cartPricing) when available, falls back to growthbook.
 */
export function isEnrolledInPositionDiscount(cartPricing?: CartPricing): boolean {
  // Prefer backend response when available
  if (cartPricing?.positionDiscounts) {
    return Object.values(cartPricing.positionDiscounts).some((d) => d.isEnrolled);
  }
  // Fall back to growthbook when no cart pricing
  return getFiGrowthBook().getFeatureValue(POSITION_DISCOUNT_FEATURE_FLAG, false);
}
